export const SHOW_MODAL = 'EmailModalContainer/SHOW_MODAL';
export const HIDE_MODAL = 'EmailModalContainer/HIDE_MODAL';

const ActionTypes = {
  SHOW_MODAL: SHOW_MODAL,
  HIDE_MODAL: HIDE_MODAL,
}

export default ActionTypes;